module.exports = __webpack_public_path__ + "img/img17.500eefd5.jpeg";